import {
  IconButton,
  Stack,
  Button,
  Box,
  Card,
  CardContent,
  CardActions,
  TextField,
  InputAdornment,
} from "@mui/material";
import {
  colorNowIcon,
  colorPredictionTool,
  AvientLogoWhite,
} from "../asset/index";
import { useState, useEffect } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { login, logout } from "../utils/index";
import { useStoreState, useStoreActions } from "easy-peasy";
import { useNavigate } from "react-router-dom";
import { CONSTANTS } from "../utils/constant";
export const Login = () => {
  let navigate = useNavigate();
  const currentUser = useStoreState((state) => state.currentUser);
  const setCurrentUser = useStoreActions((actions) => actions.setCurrentUser);
  let setRequirements = useStoreActions((actions) => actions.setRequirements);
  let setInputColor = useStoreActions((actions) => actions.setInputColor);
  
  let [username, setUsername] = useState("");
  let [password, setPassword] = useState("");
  let [Visibility, setVisibility] = useState(true);
  let changeHandlerVisibility = (event) => {
    setVisibility(!Visibility);
  };
  const [errorMessageEmail, setErrorMessageEmail] = useState("");
  const [errorMessagePassword, setErrorMessagePassword] = useState("");
  const [validEmail, setValidEmail] = useState(true);
  const [validPassword, setValidPassword] = useState(true);

  useEffect(() => {
    /** Already logged in user should redirect to Home page */
    if (currentUser && currentUser.email) {
      clearAllForms();
      navigate("/home", { replace: true });
    }
  }, []);

  let textBoxInputStyle = {
    fontFamily: "Source Sans Pro",
    color: "#303C43",
    fontSize: "16px",
    fontWeight: "400",
    borderRadius: "0px",
  };
  let formHelperTextStyle = {
    fontFamily: "Source Sans Pro",
    fontStyle: "italic",
    fontWeight: "400",
    fontSize: "14px",
    color: "#D9534F",
    position: "relative",
    right: "16px",
  };
  let loginButton = async () => {
    if (handleValidationEmail() && handleValidationPassword()) {
      try {
        /**
         *  Authentication to Firebase
         */
        let result = await login(username.toLowerCase(), password);
        if (result.email) {
          setCurrentUser({
            displayName: result.displayName || "",
            email: result.email,
          });
          clearAllForms();
          navigate("/home", { replace: true });
        } else {
          setCurrentUser({ displayName: "", email: "" });
          logout();
        }
      } catch (err) {
        setCurrentUser({ displayName: "", email: "" });
        logout();
        console.log("failed to login", err);
        window.alert("Autheication Failed");
        return;
      }
    }
  };

  const handleValidationEmail = () => {
    var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    if (!username || reg.test(username) == false) {
      setErrorMessageEmail(`Required field`);
      setValidEmail(false);
      return false;
    } else {
      setErrorMessageEmail(``);
      setValidEmail(true);
      return true;
    }
  };

  /* Clear Previous state after logout */
  const clearAllForms = () => {
    setRequirements({
      resinRequirement: {
        newResinvirgin: "",
        newResinRecycled: {
          resinName: "",
          batchNumber: "",
          thickness: "",
          rtCurve: {},
          fileName: "",
          dilutionDetails: {
            recycledResinConc: "",
            virginResinConc: "",
          },
        },
      },
      resinClass: 'PO'
    });
    setInputColor({ uploadedColorArray: [], fileName: '' });
  };


  const handleValidationPassword = () => {
    if (!password) {
      setErrorMessagePassword(`Required field`);
      setValidPassword(false);
      return false;
    } else {
      setErrorMessagePassword(``);
      setValidPassword(true);
      return true;
    }
  };
  return (
    <Box className="loginPage">
      <Stack position="relative">
        <IconButton
          size="large"
          edge="start"
          color="inherit"
          disableRipple
          className="login-avientlogo-white"
        >
          <img alt="Avient logo" src={AvientLogoWhite} />
        </IconButton>
      </Stack>{" "}
      <Card className="loginCardParent">
        <Stack direction={"column"}>
          <Box
            sx={{
              width: "100%",
              height: "8px",
              background:
                "linear-gradient(90deg, #41B54A 0%, #4EC3E0 31.77%, #3A5DAE 65.63%, #772583 100%)",
            }}
          ></Box>
          <CardContent className="loginCardContent">
            <Stack
              direction="column"
              sx={{ width: "370px", color: "#303C43" }}
              justifyContent="center"
              alignItems="center"
              spacing={3}
            >
              <IconButton
                disableRipple
                size="medium"
                sx={{ width: "168px", height: "40px" }}
                edge="start"
                color="inherit"
              >
                <img alt="avient logo" src={colorPredictionTool} />
              </IconButton>
              <Stack direction={"column"} sx={{ width: "288px" }} spacing="2">
                <Box mb={1} className="line-height-24 font-16 font-weight-600">
                  Email
                </Box>
                <TextField
                  placeholder="Username"
                  size="small"
                  required
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  helperText={errorMessageEmail}
                  error={!validEmail}
                  sx={{
                    margin: "8px 0",
                    width: "100%",
                    borderRadius: "0px",
                  }}
                  label=""
                  onError={() => {
                    style: {
                      border: "1px solid #D9534F";
                    }
                  }}
                  FormHelperTextProps={{
                    style: formHelperTextStyle,
                  }}
                  InputProps={{
                    style: textBoxInputStyle,
                  }}
                />
              </Stack>
              <Stack direction={"column"} sx={{ width: "288px" }} spacing="2">
                <Stack direction={"row"} mb={1} spacing={13}>
                  <Box className="line-height-24 font-16 font-weight-600">
                    Password
                  </Box>
                </Stack>
                <TextField
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  type={Visibility ? "password" : "text"}
                  size="small"
                  helperText={errorMessagePassword}
                  error={!validPassword}
                  sx={{
                    margin: "8px 0",
                    width: "100%",
                    borderRadius: "0px",
                  }}
                  label=""
                  onError={() => {
                    style: {
                      border: "1px solid #D9534F";
                    }
                  }}
                  FormHelperTextProps={{
                    style: formHelperTextStyle,
                  }}
                  InputProps={{
                    style: textBoxInputStyle,
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={changeHandlerVisibility}>
                          {!Visibility ? (
                            <VisibilityIcon />
                          ) : (
                            <VisibilityOffIcon />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Stack>
              <CardActions>
                <Button
                  sx={{
                    padding: "0px",
                    width: "288px",
                    height: "40px",
                    background:
                      "linear-gradient(90deg, #3A5DAE 0%, #4EC3E0 100%)",
                    borderRadius: "24px",
                    fontWeight: "600",
                    fontSize: "16px",
                    LineWeight: "24px",
                    fontFamily: "Source Sans Pro",
                    textTransform: "none",
                    boxShadow: "none",
                  }}
                  size="large"
                  fullWidth
                  variant="contained"
                  disableRipple
                  onClick={loginButton}
                >
                  Sign In
                </Button>
              </CardActions>

              <Box>
                <Box className="line-height-20 font-16 font-weight-400 text-align-center">
                  Powered by:
                </Box>
                <IconButton
                  disableRipple
                  sx={{ width: "201px", height: "48px", margin: "8px 0" }}
                  size="large"
                  edge="start"
                  color="inherit"
                  flex="1"
                >
                  <img alt="instaColr logo" src={colorNowIcon} />
                </IconButton>
              </Box>
              <Box className=" line-height-20 font-16 font-weight-400">
                {" "}
                For support, contact ColorNow team
                {/* <span className="cursor-pointer" style={{ color: "#385DAE" }}>
                  {" "}
                  {CONSTANTS.supportEmail}{" "}
                </span> */}
              </Box>
            </Stack>
          </CardContent>
        </Stack>
      </Card>
      <Box className="loginPageBottomBar">
        <span className="bottomNavLoginPageText">2024 ColorNow™</span>
      </Box>
    </Box>
  );
};
